import { createSlice } from '@reduxjs/toolkit';
import { TdsTaxSectionState } from './tdsTaxSectionTypes';
import {createTdsTaxSection,fetchTdsTaxSections,fetchTdsTaxSectionById,updateTdsTaxSection,deleteTdsTaxSection,} from './tdsTaxSectionActions';

const initialState: TdsTaxSectionState = {
  sections: [],
  selectedSection: undefined,
  loading: false,
  error: undefined,
};

const tdsTaxSectionSlice = createSlice({
  name: 'tdsTaxSection',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createTdsTaxSection.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createTdsTaxSection.fulfilled, (state, action) => {
        state.loading = false;
        state.sections.push({ ...action.meta.arg, id: action.payload.Id });
      })
      .addCase(createTdsTaxSection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All
      .addCase(fetchTdsTaxSections.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTdsTaxSections.fulfilled, (state, action) => {
        state.loading = false;
        state.sections = action.payload.data;
      })
      .addCase(fetchTdsTaxSections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch by ID
      .addCase(fetchTdsTaxSectionById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTdsTaxSectionById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedSection = action.payload;
      })
      .addCase(fetchTdsTaxSectionById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update
      .addCase(updateTdsTaxSection.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateTdsTaxSection.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.sections.findIndex(sec => sec.id === action.meta.arg.id);
        if (index !== -1) {
          state.sections[index] = { ...state.sections[index], ...action.meta.arg };
        }
      })
      .addCase(updateTdsTaxSection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete
      .addCase(deleteTdsTaxSection.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteTdsTaxSection.fulfilled, (state, action) => {
        state.loading = false;
        state.sections = state.sections.filter(section => section.id !== action.meta.arg);
      })
      .addCase(deleteTdsTaxSection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default tdsTaxSectionSlice.reducer;
